import PixelObject from './PixelObject';

export default class Polygon extends PixelObject {
    constructor(options) {
        super(options);

        const defaults = {
            type: 'POLYGON',
            name: 'Polygon',
            npoints: 3,
            radius: 25,
            width: 50,
            height: 50
        }

        let opts = { ...defaults, ...options }

        this.type = opts.type
        this.name = opts.name
        this.width = opts.width
        this.height = opts.height
        this.npoints = opts.npoints

        // make private
        this.radius = opts.radius
    }

    set(key, newValue) {
        if (PixelObject.prototype.set.call(this, key, newValue) == undefined) {
            return;
        }

        const data = {
            oldValue: this[key],
            newValue
        }

        switch (key) {
            case 'npoints': {
                this.npoints = newValue
                break;
            }
            case 'radius': {
                this.radius = newValue
                break;
            }
            default: {
                return false
            }
        }
    }


    copy() {
        return new Polygon(this)
    }

    draw() {
        if (this.visible == '0' || this.deleted) return

        const w = this.get('width')
        const h = this.get('height')
        const r = this.get('rotate')
        const radius = this.get('radius')
        const npoints = this.get('npoints')
        const selected = this.get('selected')

        this.ctx.push();

        this.stroke()
        this.fill()

        this.ctx.translate(this.width / 2, this.height / 2);
        this.ctx.rotate(this.rotate);

        let angle = this.ctx.degrees(this.ctx.TWO_PI) / this.npoints;

        this.ctx.beginShape();

        for (let a = 0; a < this.ctx.degrees(this.ctx.TWO_PI); a += angle) {
            let sx = this.x + this.ctx.cos(a) * this.radius;
            let sy = this.y + this.ctx.sin(a) * this.radius;
            this.ctx.vertex(sx, sy);
        }

        this.ctx.endShape(this.ctx.CLOSE);

        this.ctx.pop();
    }
}